import ReportAddressModal from './ReportAddressModal'

export default ReportAddressModal
